import { render, staticRenderFns } from "./RoomSuperAdmin.vue?vue&type=template&id=2646001e&scoped=true&"
import script from "./RoomSuperAdmin.vue?vue&type=script&lang=ts&"
export * from "./RoomSuperAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2646001e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2646001e')) {
      api.createRecord('2646001e', component.options)
    } else {
      api.reload('2646001e', component.options)
    }
    module.hot.accept("./RoomSuperAdmin.vue?vue&type=template&id=2646001e&scoped=true&", function () {
      api.rerender('2646001e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/rooms/room/RoomSuperAdmin.vue"
export default component.exports